module.exports = __webpack_public_path__ + "static/media/ilus-services-designsystem.821c0006.svg";